import { getRequestConfig } from 'next-intl/server';
import { notFound } from 'next/navigation';

// Supported locales - matching your existing language codes
export const locales = ['en', 'zh-Hans'] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'en';

export default getRequestConfig(async ({ locale }) => {
  // Validate that the incoming `locale` parameter is valid
  if (!locale || !locales.includes(locale as Locale)) {
    notFound();
  }

  // At this point, locale is guaranteed to be a valid Locale
  const validLocale = locale as Locale;

  // Static imports for server-side (required for Next.js build)
  let messages;
  switch (validLocale) {
    case 'en':
      messages = (await import('../../../locale/en.json')).default;
      break;
    case 'zh-Hans':
      messages = (await import('../../../locale/zh-Hans.json')).default;
      break;
    // case 'zh-Hant':
    //   messages = (await import('../locale/zh-Hant.json')).default;
    //   break;
    default:
      messages = (await import('../../../locale/en.json')).default;
  }

  return {
    locale: validLocale,
    messages
  };
});

